export default __webpack_public_path__ + "static/media/ashab.be125a56.jpg";